import Spinner from 'src/javascripts/components/utilities/Spinner';
import DonutChart from 'src/javascripts/components/charts/DonutChart';
import TrendChart from 'src/javascripts/components/charts/TrendChart';
import TrendRatings from 'src/javascripts/components/charts/TrendRatings';
import RenderParams from 'src/javascripts/components/Dashboards/RenderParams';
import AddRowClickLinks from 'src/javascripts/components/tables/AddRowClickLinks';
import ReturnsChart from 'src/javascripts/components/charts/ReturnsChart';
import ReturnsDollarsChart from 'src/javascripts/components/charts/ReturnsDollarsChart';
import ToggleReturnsChart from 'src/javascripts/components/charts/actions/ToggleReturnsChart';

export default function(el, attrs = null) {
  const accountUrl = $('body').attr('data-account-url');

  // Spinner
  Spinner(el);

  // Set vars and url
  let key = el.attr('data-key');
  let url = '/' + accountUrl + '/sections/renderings/' + key;

  // Run ajax call
  let renderCall = function() {
    let params = RenderParams(el);
    $.ajax({
      type: "GET",
      dataType: "script",
      url: url + '.js?' + $.param(params),
      success: function(response) {

        // Trend chart 
        let trendChart = el.find('.trendChart')
        if (trendChart.length !== 0) { 
          let c3NotLoadedTrend = typeof trendChart.data('c3-chart') === 'undefined';
          if (c3NotLoadedTrend) {
            trendChart.each(function() {
              let $el = $(this);
              let $chart = new TrendChart($el);
              $.when( $chart.getData() )
              .then( data => $chart.render(data) );
            })
          }
        }

        // Trend ratings chart
        let trendRatingsChart = el.find('.trendRatingsChart')
        if (trendRatingsChart.length !== 0) {
          let c3NotLoadedTrendRatings = typeof trendRatingsChart.data('c3-chart') === 'undefined';
          if (c3NotLoadedTrendRatings) {
            trendRatingsChart.each(function() {
              let $el = $(this);
              let $chart = new TrendRatings($el);
              $.when( $chart.getData() )
              .then( data => $chart.render(data) );
            })
          }
        }

        // Donut chart
        let donutChart = el.find('.donutChart')
        if (donutChart.length !== 0) {
          let hasDonut = donutChart.length !== 0
          let c3NotLoadedDonut = typeof donutChart.data('c3-chart') === 'undefined';
          if ((hasDonut) && (c3NotLoadedDonut)) {
            donutChart.each(function() {
              let $el = $(this);
              let $chart = new DonutChart($el);
              $.when( $chart.getData() )
              .then( data => $chart.render(data) );
            })
          }
        }

        // Add row click links on any rendered tables
        // This follows standard row click behavior on tables rendered through DataTables
        let renderedTable = el.find('table');
        if (renderedTable.length !== 0) {
          let tableId = renderedTable.attr('id');
          AddRowClickLinks(tableId);
        }

        // Wire up coverage table search and dial filters
        let coverageSearch = el.find('.js-coverage-search');
        let coverageFilterBtns = el.find('.js-coverage-filter');
        let coverageTable = el.find('.js-coverage-search-container').find('table');
        if (coverageSearch.length !== 0 && coverageFilterBtns.length !== 0 && coverageTable.length !== 0) {

          function applyCoverageFilters() {
            let term = (coverageSearch.val() || '').toLowerCase();
            let activeFilter = el.find('.js-coverage-filter.js-filter-active').data('filter');
            coverageTable.find('tbody tr').each(function() {
              let name = $(this).find('td:first-child').text().toLowerCase();
              let hasSurveys = $(this).hasClass('js-has-surveys');
              let matchesSearch = !term || name.indexOf(term) !== -1;
              let matchesFilter = !activeFilter ||
                (activeFilter === 'with' && hasSurveys) ||
                (activeFilter === 'without' && !hasSurveys);
              $(this).toggle(matchesSearch && matchesFilter);
            });
          }

          coverageSearch.on('input', applyCoverageFilters);

          coverageFilterBtns.on('click', function() {
            let wasActive = $(this).hasClass('js-filter-active');
            coverageFilterBtns.removeClass('js-filter-active').css('opacity', '1');
            if (!wasActive) {
              $(this).addClass('js-filter-active');
              coverageFilterBtns.not(this).css('opacity', '0.4');
            }
            applyCoverageFilters();
          });
        }

        // Returns charts
        // Initialize a new chart instance for each chart on the page
        let returnsChart = el.find('#returns_chart');
        if (returnsChart.length !== 0) {
          if ((returnsChart.attr('data-return-option') === 'percentage') && (typeof returnsChart.data('c3-chart') === 'undefined')) {

            // Set chartId and chart object
            // Get data, render chart, set up chart, and create connected table, if exists
            let chart = new ReturnsChart(returnsChart);
            $.when(chart.getData())
            .then( data => chart.render(data))
            .then( chartObj => chart.setUp(chartObj));

          } else if ((returnsChart.attr('data-return-option') === 'dollar') && (typeof returnsChart.data('c3-chart') === 'undefined')) {

            // Set chartId and chart object
            // Get data, render chart, set up chart, and create connected table, if exists
            let chart = new ReturnsDollarsChart(returnsChart);
            $.when(chart.getData())
            .then( data => chart.render(data))
            .then( chartObj => chart.setUp(chartObj));

          }

          // Toggle returns chart between hypothetical growth and percentage returns
          ToggleReturnsChart();

          // Update and reload on click
          el.find('.update-rendering').off('click').on('click', function() {
            let attr = $(this).attr('data-attr');
            let val = $(this).attr('data-value');
            el.attr('data-' + attr, val);

            // Change active date selection button
            $('.update-rendering.active').removeClass('active');
            $(this).addClass('active');
            
            renderCall();
          });

        }

      }

    })
  };
  
  // Render call
  renderCall();

  // Clear chart before caching with Turbo
  $(document).on("turbo:before-cache", function() { el.empty() })

}